import { render } from "./TermsPage.vue?vue&type=template&id=56321bce&scoped=true"
const script = {}

import "./TermsPage.vue?vue&type=style&index=0&id=56321bce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56321bce"]])

export default __exports__